import { render, staticRenderFns } from "./PanelGiveaway.vue?vue&type=template&id=0d058634&scoped=true"
import script from "./PanelGiveaway.vue?vue&type=script&lang=js"
export * from "./PanelGiveaway.vue?vue&type=script&lang=js"
import style0 from "./PanelGiveaway.vue?vue&type=style&index=0&id=0d058634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d058634",
  null
  
)

export default component.exports